unit JobCardView;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, WEBLib.DBCtrls,
  Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCPageControl, VCL.TMSFNCCustomControl,
  VCL.TMSFNCTabSet, System.Rtti, VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData,
  VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client, VCL.TMSFNCDataGrid, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter;

type
  TfrmJobCardView = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel4: TPanel;
    TMSFNCPageControl1: TTMSFNCPageControl;
    TMSFNCPageControl1Page0: TTMSFNCPageControlContainer;
    TMSFNCPageControl1Page1: TTMSFNCPageControlContainer;
    TMSFNCPageControl1Page2: TTMSFNCPageControlContainer;
    WebPanel7: TPanel;
    WebLabel4: TLabel;
    WebLabel3: TLabel;
    WebLabel2: TLabel;
    WebLabel1: TLabel;
    WebDBLabel1: TDBLabel;
    WebDBLabel2: TDBLabel;
    WebDBLabel3: TDBLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel10: TLabel;
    WebDBLabel6: TDBLabel;
    WebDBLabel8: TDBLabel;
    WebDBLabel9: TDBLabel;
    WebDBLabel10: TDBLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebDBLabel11: TDBLabel;
    WebDBLabel12: TDBLabel;
    WebDBLabel13: TDBLabel;
    WebPanel3: TPanel;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    wcJobCards: TXDataWebClient;
    wdsJobcards: TXDataWebDataSet;
    dsJobcards: TDataSource;
    WebPanel5: TPanel;
    TMSFNCDataGrid2: TTMSFNCDataGrid;
    WebPanel6: TPanel;
    TMSFNCDataGrid3: TTMSFNCDataGrid;
    WebDBMemo1: TDBMemo;
    WebLabel11: TLabel;
    wdsJobcardsCompany: TStringField;
    wdsJobcardsSite: TStringField;
    wdsJobcardsTRUCKREGNO: TStringField;
    wdsJobcardsKMREADING: TStringField;
    wdsJobcardsORDERNO: TStringField;
    wdsJobcardsREFERENCENO: TStringField;
    wdsJobcardsJOBCARDDATE: TStringField;
    wdsJobcardsJOBCARDENDDATE: TStringField;
    wdsJobcardsTotalDownTime: TStringField;
    wdsJobcardsDOCKETNO: TStringField;
    wdsJobcardsCOSTGROUP: TStringField;
    wdsJobcardsServiceType: TStringField;
    wdsJobcardsINSTRUCTIONMEMO: TStringField;
    WebLabel12: TLabel;
    WebDBLabel14: TDBLabel;
    wdsJobcardsSystemtype: TStringField;
    WebPanel8: TPanel;
    WebButton1: TButton;
    wdsJCDStandard: TXDataWebDataSet;
    dsJCDStandard: TDataSource;
    dsJCDRM: TDataSource;
    dsICDOther: TDataSource;
    wdsJCDRM: TXDataWebDataSet;
    wdsJCDOther: TXDataWebDataSet;
    dgdbaJCDStandard: TTMSFNCDataGridDatabaseAdapter;
    wdsJCDStandardstockREPLACE: TStringField;
    wdsJCDStandardVehicleType: TStringField;
    wdsJCDStandardglcode: TStringField;
    wdsJCDStandardREQQTY: TStringField;
    wdsJCDStandardstockQTY: TStringField;
    wdsJCDStandardstockUNITPRICE: TStringField;
    wdsJCDStandardTOTALEXCL: TStringField;
    wdsJCDStandardTOTALVAT: TStringField;
    wdsJCDStandardTOTALINCL: TStringField;
    wdsJCDStandardreason: TStringField;
    wdsJCDStandardWarehouse: TStringField;
    wdsJCDRMstockREPLACE: TStringField;
    wdsJCDRMVehicleType: TStringField;
    wdsJCDRMglcode: TStringField;
    wdsJCDRMREQQTY: TStringField;
    wdsJCDRMstockQTY: TStringField;
    wdsJCDRMstockUNITPRICE: TStringField;
    wdsJCDRMTOTALEXCL: TStringField;
    wdsJCDRMTOTALVAT: TStringField;
    wdsJCDRMTOTALINCL: TStringField;
    wdsJCDRMreason: TStringField;
    wdsJCDRMWarehouse: TStringField;
    wdsJCDOtherstockREPLACE: TStringField;
    wdsJCDOtherVehicleType: TStringField;
    wdsJCDOtherglcode: TStringField;
    wdsJCDOtherREQQTY: TStringField;
    wdsJCDOtherstockQTY: TStringField;
    wdsJCDOtherstockUNITPRICE: TStringField;
    wdsJCDOtherTOTALEXCL: TStringField;
    wdsJCDOtherTOTALVAT: TStringField;
    wdsJCDOtherTOTALINCL: TStringField;
    wdsJCDOtherreason: TStringField;
    wdsJCDOtherWarehouse: TStringField;
    dgdbaJCDOther: TTMSFNCDataGridDatabaseAdapter;
    dgdbaJCDRM: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCDataGrid4: TTMSFNCDataGrid;
    dgdbaTruckTrailers: TTMSFNCDataGridDatabaseAdapter;
    wcTruckTrailers: TXDataWebClient;
    wdsTruckTrailers: TXDataWebDataSet;
    dsTruckTrailers: TDataSource;
    wdsTruckTrailersRegNo: TStringField;
    wdsTruckTrailersPosition: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
  private
    { Private declarations }


    procedure LoadJobcardInfo;
    procedure loadJobCardDetail;
    procedure LoadTruckTrailers;

  public
    { Public declarations }
     JobCardNo : String;
  protected procedure LoadDFMValues; override; end;

var
  frmJobCardView: TfrmJobCardView;

implementation

{$R *.dfm}
uses
  stfmssystem.connection, share.common, share.classes;

{ TfrmJobCardView }

procedure TfrmJobCardView.loadJobCardDetail;                 //standard -> N    R+M -> Y    Other -> O
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      loadJobCardDetail;
    end;

  procedure OnSuccessO(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          loadJobCardDetail;
        end
      else
        begin
          wdsJCDOther.Close;
          wdsJCDOther.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsJCDOther.Open;
        end;
    end;



  procedure OnSuccessRM(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          loadJobCardDetail;
        end
      else
        begin
          wdsJCDRM.Close;
          wdsJCDRM.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsJCDRM.Open;

          sJson := '{"JobcardNo":"' + JobCardNo + '","RepMain":"O"}';
          wcJobCards.RawInvoke('IdashboardService.Get_JCDRepMainYNO_View',[sJson],@OnSuccessO,@OnError);
        end;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          loadJobCardDetail;
        end
      else
        begin

          wdsJCDStandard.Close;
          wdsJCDStandard.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsJCDStandard.Open;

          sJson := '{"JobcardNo":"' + JobCardNo + '","RepMain":"N"}';
          wcJobCards.RawInvoke('IdashboardService.Get_JCDRepMainYNO_View',[sJson],@OnSuccessRM,@OnError);
        end;
    end;
begin
  sJson := '{"JobcardNo":"' + JobCardNo + '","RepMain":"Y"}';

  wcJobCards.RawInvoke('IdashboardService.Get_JCDRepMainYNO_View',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmJobCardView.LoadJobcardInfo;
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
  begin
    LoadJobcardInfo;
  end;

  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadJobcardInfo;
      end
    else
      begin

        wdsJobcards.Close;
        wdsJobcards.SetJsonData(Response.Result);
        wdsJobcards.Open;

        LoadTruckTrailers


      end;
  end;

begin
  sJson := '{"OrderNo":"' + JobCardNo + '"}';

  wcJobCards.RawInvoke('IdashboardService.Get_JobCardDetailed_View',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmJobCardView.LoadTruckTrailers;
var
  sJson : String;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadTruckTrailers;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadTruckTrailers;
        end
      else
        begin

          wdsTruckTrailers.Close;
          wdsTruckTrailers.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsTruckTrailers.Open;

          loadJobCardDetail;

        end;
    end;
begin
  sJson := '{"JOBCARDNO":"' + JobCardNo + '"}';

  wcTruckTrailers.RawInvoke('IdashboardService.Get_TruckTrailers',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmJobCardView.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmJobCardView.WebFormShow(Sender: TObject);
begin

  LoadJobcardInfo;
end;

procedure TfrmJobCardView.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  TMSFNCPageControl1 := TTMSFNCPageControl.Create(Self);
  TMSFNCPageControl1Page1 := TTMSFNCPageControlContainer.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  TMSFNCDataGrid2 := TTMSFNCDataGrid.Create(Self);
  dgdbaJCDRM := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  TMSFNCPageControl1Page2 := TTMSFNCPageControlContainer.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  TMSFNCDataGrid3 := TTMSFNCDataGrid.Create(Self);
  dgdbaJCDOther := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  TMSFNCPageControl1Page0 := TTMSFNCPageControlContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgdbaJCDStandard := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel8 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebPanel7 := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  WebDBLabel2 := TDBLabel.Create(Self);
  WebDBLabel3 := TDBLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebDBLabel6 := TDBLabel.Create(Self);
  WebDBLabel8 := TDBLabel.Create(Self);
  WebDBLabel9 := TDBLabel.Create(Self);
  WebDBLabel10 := TDBLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebDBLabel11 := TDBLabel.Create(Self);
  WebDBLabel12 := TDBLabel.Create(Self);
  WebDBLabel13 := TDBLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebDBLabel14 := TDBLabel.Create(Self);
  WebDBMemo1 := TDBMemo.Create(Self);
  TMSFNCDataGrid4 := TTMSFNCDataGrid.Create(Self);
  dgdbaTruckTrailers := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcJobCards := TXDataWebClient.Create(Self);
  wdsJobcards := TXDataWebDataSet.Create(Self);
  wdsJobcardsCompany := TStringField.Create(Self);
  wdsJobcardsSite := TStringField.Create(Self);
  wdsJobcardsTRUCKREGNO := TStringField.Create(Self);
  wdsJobcardsKMREADING := TStringField.Create(Self);
  wdsJobcardsORDERNO := TStringField.Create(Self);
  wdsJobcardsREFERENCENO := TStringField.Create(Self);
  wdsJobcardsJOBCARDDATE := TStringField.Create(Self);
  wdsJobcardsJOBCARDENDDATE := TStringField.Create(Self);
  wdsJobcardsTotalDownTime := TStringField.Create(Self);
  wdsJobcardsDOCKETNO := TStringField.Create(Self);
  wdsJobcardsCOSTGROUP := TStringField.Create(Self);
  wdsJobcardsServiceType := TStringField.Create(Self);
  wdsJobcardsINSTRUCTIONMEMO := TStringField.Create(Self);
  wdsJobcardsSystemtype := TStringField.Create(Self);
  dsJobcards := TDataSource.Create(Self);
  wdsJCDStandard := TXDataWebDataSet.Create(Self);
  wdsJCDStandardstockREPLACE := TStringField.Create(Self);
  wdsJCDStandardVehicleType := TStringField.Create(Self);
  wdsJCDStandardglcode := TStringField.Create(Self);
  wdsJCDStandardREQQTY := TStringField.Create(Self);
  wdsJCDStandardstockQTY := TStringField.Create(Self);
  wdsJCDStandardstockUNITPRICE := TStringField.Create(Self);
  wdsJCDStandardTOTALEXCL := TStringField.Create(Self);
  wdsJCDStandardTOTALVAT := TStringField.Create(Self);
  wdsJCDStandardTOTALINCL := TStringField.Create(Self);
  wdsJCDStandardreason := TStringField.Create(Self);
  wdsJCDStandardWarehouse := TStringField.Create(Self);
  dsJCDStandard := TDataSource.Create(Self);
  dsJCDRM := TDataSource.Create(Self);
  dsICDOther := TDataSource.Create(Self);
  wdsJCDRM := TXDataWebDataSet.Create(Self);
  wdsJCDRMstockREPLACE := TStringField.Create(Self);
  wdsJCDRMVehicleType := TStringField.Create(Self);
  wdsJCDRMglcode := TStringField.Create(Self);
  wdsJCDRMREQQTY := TStringField.Create(Self);
  wdsJCDRMstockQTY := TStringField.Create(Self);
  wdsJCDRMstockUNITPRICE := TStringField.Create(Self);
  wdsJCDRMTOTALEXCL := TStringField.Create(Self);
  wdsJCDRMTOTALVAT := TStringField.Create(Self);
  wdsJCDRMTOTALINCL := TStringField.Create(Self);
  wdsJCDRMreason := TStringField.Create(Self);
  wdsJCDRMWarehouse := TStringField.Create(Self);
  wdsJCDOther := TXDataWebDataSet.Create(Self);
  wdsJCDOtherstockREPLACE := TStringField.Create(Self);
  wdsJCDOtherVehicleType := TStringField.Create(Self);
  wdsJCDOtherglcode := TStringField.Create(Self);
  wdsJCDOtherREQQTY := TStringField.Create(Self);
  wdsJCDOtherstockQTY := TStringField.Create(Self);
  wdsJCDOtherstockUNITPRICE := TStringField.Create(Self);
  wdsJCDOtherTOTALEXCL := TStringField.Create(Self);
  wdsJCDOtherTOTALVAT := TStringField.Create(Self);
  wdsJCDOtherTOTALINCL := TStringField.Create(Self);
  wdsJCDOtherreason := TStringField.Create(Self);
  wdsJCDOtherWarehouse := TStringField.Create(Self);
  wcTruckTrailers := TXDataWebClient.Create(Self);
  wdsTruckTrailers := TXDataWebDataSet.Create(Self);
  wdsTruckTrailersRegNo := TStringField.Create(Self);
  wdsTruckTrailersPosition := TStringField.Create(Self);
  dsTruckTrailers := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  TMSFNCPageControl1.BeforeLoadDFMValues;
  TMSFNCPageControl1Page1.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  TMSFNCDataGrid2.BeforeLoadDFMValues;
  dgdbaJCDRM.BeforeLoadDFMValues;
  TMSFNCPageControl1Page2.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  TMSFNCDataGrid3.BeforeLoadDFMValues;
  dgdbaJCDOther.BeforeLoadDFMValues;
  TMSFNCPageControl1Page0.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgdbaJCDStandard.BeforeLoadDFMValues;
  WebPanel8.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebPanel7.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  WebDBLabel2.BeforeLoadDFMValues;
  WebDBLabel3.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebDBLabel6.BeforeLoadDFMValues;
  WebDBLabel8.BeforeLoadDFMValues;
  WebDBLabel9.BeforeLoadDFMValues;
  WebDBLabel10.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebDBLabel11.BeforeLoadDFMValues;
  WebDBLabel12.BeforeLoadDFMValues;
  WebDBLabel13.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebDBLabel14.BeforeLoadDFMValues;
  WebDBMemo1.BeforeLoadDFMValues;
  TMSFNCDataGrid4.BeforeLoadDFMValues;
  dgdbaTruckTrailers.BeforeLoadDFMValues;
  wcJobCards.BeforeLoadDFMValues;
  wdsJobcards.BeforeLoadDFMValues;
  wdsJobcardsCompany.BeforeLoadDFMValues;
  wdsJobcardsSite.BeforeLoadDFMValues;
  wdsJobcardsTRUCKREGNO.BeforeLoadDFMValues;
  wdsJobcardsKMREADING.BeforeLoadDFMValues;
  wdsJobcardsORDERNO.BeforeLoadDFMValues;
  wdsJobcardsREFERENCENO.BeforeLoadDFMValues;
  wdsJobcardsJOBCARDDATE.BeforeLoadDFMValues;
  wdsJobcardsJOBCARDENDDATE.BeforeLoadDFMValues;
  wdsJobcardsTotalDownTime.BeforeLoadDFMValues;
  wdsJobcardsDOCKETNO.BeforeLoadDFMValues;
  wdsJobcardsCOSTGROUP.BeforeLoadDFMValues;
  wdsJobcardsServiceType.BeforeLoadDFMValues;
  wdsJobcardsINSTRUCTIONMEMO.BeforeLoadDFMValues;
  wdsJobcardsSystemtype.BeforeLoadDFMValues;
  dsJobcards.BeforeLoadDFMValues;
  wdsJCDStandard.BeforeLoadDFMValues;
  wdsJCDStandardstockREPLACE.BeforeLoadDFMValues;
  wdsJCDStandardVehicleType.BeforeLoadDFMValues;
  wdsJCDStandardglcode.BeforeLoadDFMValues;
  wdsJCDStandardREQQTY.BeforeLoadDFMValues;
  wdsJCDStandardstockQTY.BeforeLoadDFMValues;
  wdsJCDStandardstockUNITPRICE.BeforeLoadDFMValues;
  wdsJCDStandardTOTALEXCL.BeforeLoadDFMValues;
  wdsJCDStandardTOTALVAT.BeforeLoadDFMValues;
  wdsJCDStandardTOTALINCL.BeforeLoadDFMValues;
  wdsJCDStandardreason.BeforeLoadDFMValues;
  wdsJCDStandardWarehouse.BeforeLoadDFMValues;
  dsJCDStandard.BeforeLoadDFMValues;
  dsJCDRM.BeforeLoadDFMValues;
  dsICDOther.BeforeLoadDFMValues;
  wdsJCDRM.BeforeLoadDFMValues;
  wdsJCDRMstockREPLACE.BeforeLoadDFMValues;
  wdsJCDRMVehicleType.BeforeLoadDFMValues;
  wdsJCDRMglcode.BeforeLoadDFMValues;
  wdsJCDRMREQQTY.BeforeLoadDFMValues;
  wdsJCDRMstockQTY.BeforeLoadDFMValues;
  wdsJCDRMstockUNITPRICE.BeforeLoadDFMValues;
  wdsJCDRMTOTALEXCL.BeforeLoadDFMValues;
  wdsJCDRMTOTALVAT.BeforeLoadDFMValues;
  wdsJCDRMTOTALINCL.BeforeLoadDFMValues;
  wdsJCDRMreason.BeforeLoadDFMValues;
  wdsJCDRMWarehouse.BeforeLoadDFMValues;
  wdsJCDOther.BeforeLoadDFMValues;
  wdsJCDOtherstockREPLACE.BeforeLoadDFMValues;
  wdsJCDOtherVehicleType.BeforeLoadDFMValues;
  wdsJCDOtherglcode.BeforeLoadDFMValues;
  wdsJCDOtherREQQTY.BeforeLoadDFMValues;
  wdsJCDOtherstockQTY.BeforeLoadDFMValues;
  wdsJCDOtherstockUNITPRICE.BeforeLoadDFMValues;
  wdsJCDOtherTOTALEXCL.BeforeLoadDFMValues;
  wdsJCDOtherTOTALVAT.BeforeLoadDFMValues;
  wdsJCDOtherTOTALINCL.BeforeLoadDFMValues;
  wdsJCDOtherreason.BeforeLoadDFMValues;
  wdsJCDOtherWarehouse.BeforeLoadDFMValues;
  wcTruckTrailers.BeforeLoadDFMValues;
  wdsTruckTrailers.BeforeLoadDFMValues;
  wdsTruckTrailersRegNo.BeforeLoadDFMValues;
  wdsTruckTrailersPosition.BeforeLoadDFMValues;
  dsTruckTrailers.BeforeLoadDFMValues;
  try
    Name := 'frmJobCardView';
    Width := 1000;
    Height := 816;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1000;
    WebPanel1.Height := 816;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 1000;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'JobCard Detail';
    WebPanel2.Color := clSilver;
    WebPanel2.TabOrder := 0;
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 347;
    WebPanel4.Width := 1000;
    WebPanel4.Height := 469;
    WebPanel4.Align := alClient;
    WebPanel4.ChildOrder := 2;
    WebPanel4.TabOrder := 1;
    TMSFNCPageControl1.SetParentComponent(WebPanel4);
    TMSFNCPageControl1.Name := 'TMSFNCPageControl1';
    TMSFNCPageControl1.Left := 0;
    TMSFNCPageControl1.Top := 0;
    TMSFNCPageControl1.Width := 1000;
    TMSFNCPageControl1.Height := 409;
    TMSFNCPageControl1.Align := alClient;
    TMSFNCPageControl1.ParentDoubleBuffered := False;
    TMSFNCPageControl1.Color := clBtnFace;
    TMSFNCPageControl1.DoubleBuffered := True;
    TMSFNCPageControl1.TabOrder := 0;
    TMSFNCPageControl1.Fill.Kind := gfkNone;
    TMSFNCPageControl1.Stroke.Kind := gskNone;
    TMSFNCPageControl1.TabAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCPageControl1.TabAppearance.Font.Color := clWindowText;
    TMSFNCPageControl1.TabAppearance.Font.Height := -12;
    TMSFNCPageControl1.TabAppearance.Font.Name := 'Segoe UI';
    TMSFNCPageControl1.TabAppearance.Font.Style := [];
    TMSFNCPageControl1.TabAppearance.Fill.Color := 16578806;
    TMSFNCPageControl1.TabAppearance.DownFill.Color := 15776936;
    TMSFNCPageControl1.TabAppearance.DownStroke.Color := 15702829;
    TMSFNCPageControl1.TabAppearance.HoverFill.Color := 16380654;
    TMSFNCPageControl1.TabAppearance.HoverStroke.Color := 15702829;
    TMSFNCPageControl1.TabAppearance.TextSpacing := 0.000000000000000000;
    TMSFNCPageControl1.TabAppearance.TextColor := 8026746;
    TMSFNCPageControl1.TabAppearance.ActiveTextColor := 4539717;
    TMSFNCPageControl1.TabAppearance.HoverTextColor := 8026746;
    TMSFNCPageControl1.TabAppearance.DownTextColor := 4539717;
    TMSFNCPageControl1.TabAppearance.ShowFocus := False;
    TMSFNCPageControl1.TabAppearance.CloseStroke.Width := 2.000000000000000000;
    TMSFNCPageControl1.TabAppearance.CloseDownStroke.Width := 2.000000000000000000;
    TMSFNCPageControl1.TabAppearance.CloseHoverStroke.Width := 2.000000000000000000;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Color := clDarkred;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Height := -12;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Name := 'Segoe UI';
    TMSFNCPageControl1.TabAppearance.BadgeFont.Style := [fsBold];
    TMSFNCPageControl1.ButtonAppearance.CloseIcon.LoadFromFile('JobCardView.WebPanel4.TMSFNCPageControl1.ButtonAppearance.CloseIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.InsertIcon.LoadFromFile('JobCardView.WebPanel4.TMSFNCPageControl1.ButtonAppearance.InsertIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.TabListIcon.LoadFromFile('JobCardView.WebPanel4.TMSFNCPageControl1.ButtonAppearance.TabListIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.ScrollNextIcon.LoadFromFile('JobCardView.WebPanel4.TMSFNCPageControl1.ButtonAppearance.ScrollNextIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.ScrollPreviousIcon.LoadFromFile('JobCardView.WebPanel4.TMSFNCPageControl1.ButtonAppearance.ScrollPreviousIcon.svg');
    TMSFNCPageControl1.TabSize.Margins.Left := 8.000000000000000000;
    TMSFNCPageControl1.TabSize.Margins.Top := 8.000000000000000000;
    TMSFNCPageControl1.TabSize.Margins.Right := 8.000000000000000000;
    TMSFNCPageControl1.TabSize.Margins.Bottom := 8.000000000000000000;
    TMSFNCPageControl1.Pages.Clear;
    with TMSFNCPageControl1.Pages.Add do
    begin
      Text := 'Standard';
      UseDefaultAppearance := True;
    end;
    with TMSFNCPageControl1.Pages.Add do
    begin
      Text := 'R + M';
      UseDefaultAppearance := True;
    end;
    with TMSFNCPageControl1.Pages.Add do
    begin
      Text := 'Other';
      UseDefaultAppearance := True;
    end;
    TMSFNCPageControl1Page1.SetParentComponent(TMSFNCPageControl1);
    TMSFNCPageControl1Page1.Name := 'TMSFNCPageControl1Page1';
    TMSFNCPageControl1Page1.AlignWithMargins := True;
    TMSFNCPageControl1Page1.Left := 0;
    TMSFNCPageControl1Page1.Top := 29;
    TMSFNCPageControl1Page1.Width := 1000;
    TMSFNCPageControl1Page1.Height := 380;
    TMSFNCPageControl1Page1.Margins.Left := 0;
    TMSFNCPageControl1Page1.Margins.Top := 29;
    TMSFNCPageControl1Page1.Margins.Right := 0;
    TMSFNCPageControl1Page1.Margins.Bottom := 0;
    TMSFNCPageControl1Page1.Align := alClient;
    TMSFNCPageControl1Page1.ParentDoubleBuffered := False;
    TMSFNCPageControl1Page1.DoubleBuffered := True;
    TMSFNCPageControl1Page1.TabStop := False;
    TMSFNCPageControl1Page1.TabOrder := 1;
    TMSFNCPageControl1Page1.Visible := False;
    TMSFNCPageControl1Page1.PageIndex := 1;
    TMSFNCPageControl1Page1.IsActive := False;
    WebPanel5.SetParentComponent(TMSFNCPageControl1Page1);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 0;
    WebPanel5.Top := 0;
    WebPanel5.Width := 1000;
    WebPanel5.Height := 380;
    WebPanel5.Align := alClient;
    WebPanel5.TabOrder := 0;
    TMSFNCDataGrid2.SetParentComponent(WebPanel5);
    TMSFNCDataGrid2.Name := 'TMSFNCDataGrid2';
    TMSFNCDataGrid2.Left := 0;
    TMSFNCDataGrid2.Top := 0;
    TMSFNCDataGrid2.Width := 1000;
    TMSFNCDataGrid2.Height := 380;
    TMSFNCDataGrid2.Align := alClient;
    TMSFNCDataGrid2.ParentDoubleBuffered := False;
    TMSFNCDataGrid2.DoubleBuffered := True;
    TMSFNCDataGrid2.TabOrder := 0;
    TMSFNCDataGrid2.ShowAcceleratorChar := False;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid2.Adapter := dgdbaJCDRM;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid2.ColumnCount := 13;
    TMSFNCDataGrid2.Columns.Clear;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Repl';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Combination Type';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Unit Price';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Combination Type';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'GL Code';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'REQQTY';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'stockQTY';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'stock Unit Price';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL EXCL';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL VAT';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL INCL';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'reason';
      Width := 250.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Warehouse';
      Width := 0.000000000000000000;
    end;
    TMSFNCDataGrid2.Designer := False;
    TMSFNCDataGrid2.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid2.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid2.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid2.Icons.ExpandIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.ExpandIcon.svg');
    TMSFNCDataGrid2.Icons.CollapseIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.CollapseIcon.svg');
    TMSFNCDataGrid2.Icons.FilterIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.FilterIcon.svg');
    TMSFNCDataGrid2.Icons.FilterActiveIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid2.Icons.FilterClearIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid2.Icons.FilterTypeIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid2.Icons.SortAscendingIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid2.Icons.SortDescendingIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid2.Icons.CloseIcon.LoadFromFile('JobCardView.WebPanel5.TMSFNCDataGrid2.Icons.CloseIcon.svg');
    TMSFNCDataGrid2.RowCount := 1;
    dgdbaJCDRM.SetParentComponent(TMSFNCDataGrid2);
    dgdbaJCDRM.Name := 'dgdbaJCDRM';
    dgdbaJCDRM.Left := 264;
    dgdbaJCDRM.Top := 176;
    dgdbaJCDRM.Width := 26;
    dgdbaJCDRM.Height := 26;
    dgdbaJCDRM.Visible := True;
    dgdbaJCDRM.Columns.Clear;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'stockREPLACE';
      Header := 'Stock Repl';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'VehicleType';
      Header := 'Combination Type';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'stockUNITPRICE';
      Header := 'Stock Unit Price';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'VehicleType';
      Header := 'Combination Type';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'glcode';
      Header := 'GL Code';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'REQQTY';
      Header := 'REQQTY';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'stockQTY';
      Header := 'stockQTY';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'stockUNITPRICE';
      Header := 'stock Unit Price';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'TOTALEXCL';
      Header := 'TOTAL EXCL';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'TOTALVAT';
      Header := 'TOTAL VAT';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'TOTALINCL';
      Header := 'TOTAL INCL';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'reason';
      Header := 'reason';
      AutoCreated := False;
    end;
    with dgdbaJCDRM.Columns.Add do
    begin
      FieldName := 'Warehouse';
      Header := 'Warehouse';
      AutoCreated := False;
    end;
    dgdbaJCDRM.DataSource := dsJCDRM;
    TMSFNCPageControl1Page2.SetParentComponent(TMSFNCPageControl1);
    TMSFNCPageControl1Page2.Name := 'TMSFNCPageControl1Page2';
    TMSFNCPageControl1Page2.AlignWithMargins := True;
    TMSFNCPageControl1Page2.Left := 0;
    TMSFNCPageControl1Page2.Top := 29;
    TMSFNCPageControl1Page2.Width := 1000;
    TMSFNCPageControl1Page2.Height := 380;
    TMSFNCPageControl1Page2.Margins.Left := 0;
    TMSFNCPageControl1Page2.Margins.Top := 29;
    TMSFNCPageControl1Page2.Margins.Right := 0;
    TMSFNCPageControl1Page2.Margins.Bottom := 0;
    TMSFNCPageControl1Page2.Align := alClient;
    TMSFNCPageControl1Page2.ParentDoubleBuffered := False;
    TMSFNCPageControl1Page2.DoubleBuffered := True;
    TMSFNCPageControl1Page2.TabStop := False;
    TMSFNCPageControl1Page2.TabOrder := 2;
    TMSFNCPageControl1Page2.Visible := False;
    TMSFNCPageControl1Page2.PageIndex := 2;
    TMSFNCPageControl1Page2.IsActive := False;
    WebPanel6.SetParentComponent(TMSFNCPageControl1Page2);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 0;
    WebPanel6.Width := 1000;
    WebPanel6.Height := 380;
    WebPanel6.Align := alClient;
    WebPanel6.TabOrder := 0;
    TMSFNCDataGrid3.SetParentComponent(WebPanel6);
    TMSFNCDataGrid3.Name := 'TMSFNCDataGrid3';
    TMSFNCDataGrid3.Left := 0;
    TMSFNCDataGrid3.Top := 0;
    TMSFNCDataGrid3.Width := 1000;
    TMSFNCDataGrid3.Height := 380;
    TMSFNCDataGrid3.Align := alClient;
    TMSFNCDataGrid3.ParentDoubleBuffered := False;
    TMSFNCDataGrid3.DoubleBuffered := True;
    TMSFNCDataGrid3.TabOrder := 0;
    TMSFNCDataGrid3.ShowAcceleratorChar := False;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid3.Adapter := dgdbaJCDOther;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid3.ColumnCount := 13;
    TMSFNCDataGrid3.Columns.Clear;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Repl';
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Combination Type';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Unit Price';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Combination Type';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'GL Code';
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'REQQTY';
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'stockQTY';
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'stock Unit Price';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL EXCL';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL VAT';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL INCL';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'reason';
      Width := 250.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Warehouse';
      Width := 0.000000000000000000;
    end;
    TMSFNCDataGrid3.Designer := False;
    TMSFNCDataGrid3.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid3.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid3.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid3.Icons.ExpandIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.ExpandIcon.svg');
    TMSFNCDataGrid3.Icons.CollapseIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.CollapseIcon.svg');
    TMSFNCDataGrid3.Icons.FilterIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.FilterIcon.svg');
    TMSFNCDataGrid3.Icons.FilterActiveIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid3.Icons.FilterClearIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid3.Icons.FilterTypeIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid3.Icons.SortAscendingIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid3.Icons.SortDescendingIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid3.Icons.CloseIcon.LoadFromFile('JobCardView.WebPanel6.TMSFNCDataGrid3.Icons.CloseIcon.svg');
    TMSFNCDataGrid3.RowCount := 1;
    dgdbaJCDOther.SetParentComponent(TMSFNCDataGrid3);
    dgdbaJCDOther.Name := 'dgdbaJCDOther';
    dgdbaJCDOther.Left := 575;
    dgdbaJCDOther.Top := 184;
    dgdbaJCDOther.Width := 26;
    dgdbaJCDOther.Height := 26;
    dgdbaJCDOther.Visible := True;
    dgdbaJCDOther.Columns.Clear;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'stockREPLACE';
      Header := 'Stock Repl';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'VehicleType';
      Header := 'Combination Type';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'stockUNITPRICE';
      Header := 'Stock Unit Price';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'VehicleType';
      Header := 'Combination Type';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'glcode';
      Header := 'GL Code';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'REQQTY';
      Header := 'REQQTY';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'stockQTY';
      Header := 'stockQTY';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'stockUNITPRICE';
      Header := 'stock Unit Price';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'TOTALEXCL';
      Header := 'TOTAL EXCL';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'TOTALVAT';
      Header := 'TOTAL VAT';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'TOTALINCL';
      Header := 'TOTAL INCL';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'reason';
      Header := 'reason';
      AutoCreated := False;
    end;
    with dgdbaJCDOther.Columns.Add do
    begin
      FieldName := 'Warehouse';
      Header := 'Warehouse';
      AutoCreated := False;
    end;
    dgdbaJCDOther.DataSource := dsICDOther;
    TMSFNCPageControl1Page0.SetParentComponent(TMSFNCPageControl1);
    TMSFNCPageControl1Page0.Name := 'TMSFNCPageControl1Page0';
    TMSFNCPageControl1Page0.AlignWithMargins := True;
    TMSFNCPageControl1Page0.Left := 0;
    TMSFNCPageControl1Page0.Top := 29;
    TMSFNCPageControl1Page0.Width := 1000;
    TMSFNCPageControl1Page0.Height := 380;
    TMSFNCPageControl1Page0.Margins.Left := 0;
    TMSFNCPageControl1Page0.Margins.Top := 29;
    TMSFNCPageControl1Page0.Margins.Right := 0;
    TMSFNCPageControl1Page0.Margins.Bottom := 0;
    TMSFNCPageControl1Page0.Align := alClient;
    TMSFNCPageControl1Page0.ParentDoubleBuffered := False;
    TMSFNCPageControl1Page0.DoubleBuffered := True;
    TMSFNCPageControl1Page0.TabStop := False;
    TMSFNCPageControl1Page0.TabOrder := 0;
    TMSFNCPageControl1Page0.PageIndex := 0;
    TMSFNCPageControl1Page0.IsActive := True;
    WebPanel3.SetParentComponent(TMSFNCPageControl1Page0);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 0;
    WebPanel3.Width := 1000;
    WebPanel3.Height := 380;
    WebPanel3.Align := alClient;
    WebPanel3.TabOrder := 0;
    TMSFNCDataGrid1.SetParentComponent(WebPanel3);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 0;
    TMSFNCDataGrid1.Width := 1000;
    TMSFNCDataGrid1.Height := 380;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 0;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaJCDStandard;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 13;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Repl';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Combination Type';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Unit Price';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Combination Type';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'GL Code';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'REQQTY';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'stockQTY';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'stock Unit Price';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL EXCL';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL VAT';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTAL INCL';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'reason';
      Width := 250.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Warehouse';
      Width := 0.000000000000000000;
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('JobCardView.WebPanel3.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    TMSFNCDataGrid1.RowCount := 1;
    dgdbaJCDStandard.SetParentComponent(TMSFNCDataGrid1);
    dgdbaJCDStandard.Name := 'dgdbaJCDStandard';
    dgdbaJCDStandard.Left := 264;
    dgdbaJCDStandard.Top := 232;
    dgdbaJCDStandard.Width := 26;
    dgdbaJCDStandard.Height := 26;
    dgdbaJCDStandard.Visible := True;
    dgdbaJCDStandard.Columns.Clear;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'stockREPLACE';
      Header := 'Stock Repl';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'VehicleType';
      Header := 'Combination Type';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'stockUNITPRICE';
      Header := 'Stock Unit Price';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'VehicleType';
      Header := 'Combination Type';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'glcode';
      Header := 'GL Code';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'REQQTY';
      Header := 'REQQTY';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'stockQTY';
      Header := 'stockQTY';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'stockUNITPRICE';
      Header := 'stock Unit Price';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'TOTALEXCL';
      Header := 'TOTAL EXCL';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'TOTALVAT';
      Header := 'TOTAL VAT';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'TOTALINCL';
      Header := 'TOTAL INCL';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'reason';
      Header := 'reason';
      AutoCreated := False;
    end;
    with dgdbaJCDStandard.Columns.Add do
    begin
      FieldName := 'Warehouse';
      Header := 'Warehouse';
      AutoCreated := False;
    end;
    dgdbaJCDStandard.DataSource := dsJCDStandard;
    WebPanel8.SetParentComponent(WebPanel4);
    WebPanel8.Name := 'WebPanel8';
    WebPanel8.Left := 0;
    WebPanel8.Top := 409;
    WebPanel8.Width := 1000;
    WebPanel8.Height := 60;
    WebPanel8.Align := alBottom;
    WebPanel8.ChildOrder := 1;
    WebPanel8.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel8);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 14;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 33;
    WebButton1.Caption := 'Close';
    WebButton1.Color := clRed;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebPanel7.SetParentComponent(WebPanel1);
    WebPanel7.Name := 'WebPanel7';
    WebPanel7.Left := 0;
    WebPanel7.Top := 60;
    WebPanel7.Width := 1000;
    WebPanel7.Height := 287;
    WebPanel7.Align := alTop;
    WebPanel7.ChildOrder := 5;
    WebPanel7.TabOrder := 2;
    WebLabel4.SetParentComponent(WebPanel7);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 13;
    WebLabel4.Top := 123;
    WebLabel4.Width := 40;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Trailers:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel7);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 13;
    WebLabel3.Top := 90;
    WebLabel3.Width := 63;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Vehicle Reg:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel7);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 13;
    WebLabel2.Top := 57;
    WebLabel2.Width := 28;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Site : ';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel7);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 13;
    WebLabel1.Top := 25;
    WebLabel1.Width := 58;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Company :';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.SetParentComponent(WebPanel7);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 88;
    WebDBLabel1.Top := 25;
    WebDBLabel1.Width := 73;
    WebDBLabel1.Height := 15;
    WebDBLabel1.Caption := 'WebDBLabel1';
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'Company';
    WebDBLabel1.DataSource := dsJobcards;
    WebDBLabel2.SetParentComponent(WebPanel7);
    WebDBLabel2.Name := 'WebDBLabel2';
    WebDBLabel2.Left := 88;
    WebDBLabel2.Top := 57;
    WebDBLabel2.Width := 73;
    WebDBLabel2.Height := 15;
    WebDBLabel2.Caption := 'WebDBLabel2';
    WebDBLabel2.HeightPercent := 100.000000000000000000;
    WebDBLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.DataField := 'Site';
    WebDBLabel2.DataSource := dsJobcards;
    WebDBLabel3.SetParentComponent(WebPanel7);
    WebDBLabel3.Name := 'WebDBLabel3';
    WebDBLabel3.Left := 88;
    WebDBLabel3.Top := 90;
    WebDBLabel3.Width := 73;
    WebDBLabel3.Height := 15;
    WebDBLabel3.Caption := 'WebDBLabel3';
    WebDBLabel3.HeightPercent := 100.000000000000000000;
    WebDBLabel3.WidthPercent := 100.000000000000000000;
    WebDBLabel3.DataField := 'TRUCKREGNO';
    WebDBLabel3.DataSource := dsJobcards;
    WebLabel6.SetParentComponent(WebPanel7);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 390;
    WebLabel6.Top := 122;
    WebLabel6.Width := 50;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'End Date:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel7);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 389;
    WebLabel7.Top := 90;
    WebLabel7.Width := 57;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Start Date::';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel7);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 389;
    WebLabel8.Top := 57;
    WebLabel8.Width := 58;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Reference :';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel7);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 389;
    WebLabel10.Top := 25;
    WebLabel10.Width := 62;
    WebLabel10.Height := 15;
    WebLabel10.Caption := 'Kilometers :';
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel6.SetParentComponent(WebPanel7);
    WebDBLabel6.Name := 'WebDBLabel6';
    WebDBLabel6.Left := 464;
    WebDBLabel6.Top := 25;
    WebDBLabel6.Width := 73;
    WebDBLabel6.Height := 15;
    WebDBLabel6.Caption := 'WebDBLabel1';
    WebDBLabel6.HeightPercent := 100.000000000000000000;
    WebDBLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel6.DataField := 'KMREADING';
    WebDBLabel6.DataSource := dsJobcards;
    WebDBLabel8.SetParentComponent(WebPanel7);
    WebDBLabel8.Name := 'WebDBLabel8';
    WebDBLabel8.Left := 464;
    WebDBLabel8.Top := 57;
    WebDBLabel8.Width := 73;
    WebDBLabel8.Height := 15;
    WebDBLabel8.Caption := 'WebDBLabel3';
    WebDBLabel8.HeightPercent := 100.000000000000000000;
    WebDBLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel8.DataField := 'REFERENCENO';
    WebDBLabel8.DataSource := dsJobcards;
    WebDBLabel9.SetParentComponent(WebPanel7);
    WebDBLabel9.Name := 'WebDBLabel9';
    WebDBLabel9.Left := 464;
    WebDBLabel9.Top := 90;
    WebDBLabel9.Width := 73;
    WebDBLabel9.Height := 15;
    WebDBLabel9.Caption := 'WebDBLabel4';
    WebDBLabel9.HeightPercent := 100.000000000000000000;
    WebDBLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.DataField := 'JOBCARDDATE';
    WebDBLabel9.DataSource := dsJobcards;
    WebDBLabel10.SetParentComponent(WebPanel7);
    WebDBLabel10.Name := 'WebDBLabel10';
    WebDBLabel10.Left := 464;
    WebDBLabel10.Top := 122;
    WebDBLabel10.Width := 73;
    WebDBLabel10.Height := 15;
    WebDBLabel10.Caption := 'WebDBLabel5';
    WebDBLabel10.HeightPercent := 100.000000000000000000;
    WebDBLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel10.DataField := 'JOBCARDENDDATE';
    WebDBLabel10.DataSource := dsJobcards;
    WebLabel13.SetParentComponent(WebPanel7);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 390;
    WebLabel13.Top := 244;
    WebLabel13.Width := 69;
    WebLabel13.Height := 15;
    WebLabel13.Caption := 'System Type:';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel7);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 390;
    WebLabel14.Top := 211;
    WebLabel14.Width := 71;
    WebLabel14.Height := 15;
    WebLabel14.Caption := 'Service Type :';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel7);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 390;
    WebLabel15.Top := 179;
    WebLabel15.Width := 82;
    WebLabel15.Height := 15;
    WebLabel15.Caption := 'Costing Center:';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebDBLabel11.SetParentComponent(WebPanel7);
    WebDBLabel11.Name := 'WebDBLabel11';
    WebDBLabel11.Left := 475;
    WebDBLabel11.Top := 179;
    WebDBLabel11.Width := 73;
    WebDBLabel11.Height := 15;
    WebDBLabel11.Caption := 'WebDBLabel1';
    WebDBLabel11.HeightPercent := 100.000000000000000000;
    WebDBLabel11.WidthPercent := 100.000000000000000000;
    WebDBLabel11.DataField := 'COSTGROUP';
    WebDBLabel11.DataSource := dsJobcards;
    WebDBLabel12.SetParentComponent(WebPanel7);
    WebDBLabel12.Name := 'WebDBLabel12';
    WebDBLabel12.Left := 465;
    WebDBLabel12.Top := 211;
    WebDBLabel12.Width := 73;
    WebDBLabel12.Height := 15;
    WebDBLabel12.Caption := 'WebDBLabel2';
    WebDBLabel12.HeightPercent := 100.000000000000000000;
    WebDBLabel12.WidthPercent := 100.000000000000000000;
    WebDBLabel12.DataField := 'ServiceType';
    WebDBLabel12.DataSource := dsJobcards;
    WebDBLabel13.SetParentComponent(WebPanel7);
    WebDBLabel13.Name := 'WebDBLabel13';
    WebDBLabel13.Left := 465;
    WebDBLabel13.Top := 244;
    WebDBLabel13.Width := 73;
    WebDBLabel13.Height := 15;
    WebDBLabel13.Caption := 'WebDBLabel3';
    WebDBLabel13.HeightPercent := 100.000000000000000000;
    WebDBLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel13.DataField := 'Systemtype';
    WebDBLabel13.DataSource := dsJobcards;
    WebLabel11.SetParentComponent(WebPanel7);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 590;
    WebLabel11.Top := 23;
    WebLabel11.Width := 34;
    WebLabel11.Height := 15;
    WebLabel11.Caption := 'Notes:';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebPanel7);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 390;
    WebLabel12.Top := 153;
    WebLabel12.Width := 93;
    WebLabel12.Height := 15;
    WebLabel12.Caption := 'Total Down Time:';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebDBLabel14.SetParentComponent(WebPanel7);
    WebDBLabel14.Name := 'WebDBLabel14';
    WebDBLabel14.Left := 489;
    WebDBLabel14.Top := 153;
    WebDBLabel14.Width := 79;
    WebDBLabel14.Height := 15;
    WebDBLabel14.Caption := 'WebDBLabel14';
    WebDBLabel14.HeightPercent := 100.000000000000000000;
    WebDBLabel14.WidthPercent := 100.000000000000000000;
    WebDBLabel14.DataField := 'TotalDownTime';
    WebDBLabel14.DataSource := dsJobcards;
    WebDBMemo1.SetParentComponent(WebPanel7);
    WebDBMemo1.Name := 'WebDBMemo1';
    WebDBMemo1.Left := 589;
    WebDBMemo1.Top := 40;
    WebDBMemo1.Width := 348;
    WebDBMemo1.Height := 219;
    WebDBMemo1.HeightPercent := 100.000000000000000000;
    WebDBMemo1.Lines.BeginUpdate;
    try
      WebDBMemo1.Lines.Clear;
      WebDBMemo1.Lines.Add('WebDBMemo1');
    finally
      WebDBMemo1.Lines.EndUpdate;
    end;
    WebDBMemo1.SelLength := 0;
    WebDBMemo1.SelStart := 0;
    WebDBMemo1.WidthPercent := 100.000000000000000000;
    WebDBMemo1.DataField := 'INSTRUCTIONMEMO';
    WebDBMemo1.DataSource := dsJobcards;
    TMSFNCDataGrid4.SetParentComponent(WebPanel7);
    TMSFNCDataGrid4.Name := 'TMSFNCDataGrid4';
    TMSFNCDataGrid4.Left := 59;
    TMSFNCDataGrid4.Top := 115;
    TMSFNCDataGrid4.Width := 275;
    TMSFNCDataGrid4.Height := 111;
    TMSFNCDataGrid4.ParentDoubleBuffered := False;
    TMSFNCDataGrid4.DoubleBuffered := True;
    TMSFNCDataGrid4.TabOrder := 1;
    TMSFNCDataGrid4.ShowAcceleratorChar := False;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid4.Adapter := dgdbaTruckTrailers;
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid4.ColumnCount := 2;
    TMSFNCDataGrid4.Columns.Clear;
    with TMSFNCDataGrid4.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Trailer Reg';
      Width := 200.000000000000000000;
    end;
    with TMSFNCDataGrid4.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Position';
    end;
    TMSFNCDataGrid4.Designer := False;
    TMSFNCDataGrid4.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid4.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid4.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid4.Icons.ExpandIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.ExpandIcon.svg');
    TMSFNCDataGrid4.Icons.CollapseIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.CollapseIcon.svg');
    TMSFNCDataGrid4.Icons.FilterIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.FilterIcon.svg');
    TMSFNCDataGrid4.Icons.FilterActiveIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid4.Icons.FilterClearIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid4.Icons.FilterTypeIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid4.Icons.SortAscendingIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid4.Icons.SortDescendingIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid4.Icons.CloseIcon.LoadFromFile('JobCardView.WebPanel7.TMSFNCDataGrid4.Icons.CloseIcon.svg');
    TMSFNCDataGrid4.RowCount := 1;
    dgdbaTruckTrailers.SetParentComponent(TMSFNCDataGrid4);
    dgdbaTruckTrailers.Name := 'dgdbaTruckTrailers';
    dgdbaTruckTrailers.Left := 3;
    dgdbaTruckTrailers.Top := 3;
    dgdbaTruckTrailers.Width := 26;
    dgdbaTruckTrailers.Height := 26;
    dgdbaTruckTrailers.Visible := True;
    dgdbaTruckTrailers.Columns.Clear;
    with dgdbaTruckTrailers.Columns.Add do
    begin
      FieldName := 'RegNo';
      Header := 'Trailer Reg';
      AutoCreated := False;
    end;
    with dgdbaTruckTrailers.Columns.Add do
    begin
      FieldName := 'Position';
      Header := 'Position';
      AutoCreated := False;
    end;
    dgdbaTruckTrailers.DataSource := dsTruckTrailers;
    wcJobCards.SetParentComponent(Self);
    wcJobCards.Name := 'wcJobCards';
    wcJobCards.Connection := dmData.dbConnect;
    wcJobCards.Left := 120;
    wcJobCards.Top := 24;
    wdsJobcards.SetParentComponent(Self);
    wdsJobcards.Name := 'wdsJobcards';
    wdsJobcards.Connection := dmData.dbConnect;
    wdsJobcards.Left := 192;
    wdsJobcards.Top := 24;
    wdsJobcardsCompany.SetParentComponent(wdsJobcards);
    wdsJobcardsCompany.Name := 'wdsJobcardsCompany';
    wdsJobcardsCompany.FieldName := 'Company';
    wdsJobcardsSite.SetParentComponent(wdsJobcards);
    wdsJobcardsSite.Name := 'wdsJobcardsSite';
    wdsJobcardsSite.FieldName := 'Site';
    wdsJobcardsTRUCKREGNO.SetParentComponent(wdsJobcards);
    wdsJobcardsTRUCKREGNO.Name := 'wdsJobcardsTRUCKREGNO';
    wdsJobcardsTRUCKREGNO.FieldName := 'TRUCKREGNO';
    wdsJobcardsKMREADING.SetParentComponent(wdsJobcards);
    wdsJobcardsKMREADING.Name := 'wdsJobcardsKMREADING';
    wdsJobcardsKMREADING.FieldName := 'KMREADING';
    wdsJobcardsORDERNO.SetParentComponent(wdsJobcards);
    wdsJobcardsORDERNO.Name := 'wdsJobcardsORDERNO';
    wdsJobcardsORDERNO.FieldName := 'ORDERNO';
    wdsJobcardsREFERENCENO.SetParentComponent(wdsJobcards);
    wdsJobcardsREFERENCENO.Name := 'wdsJobcardsREFERENCENO';
    wdsJobcardsREFERENCENO.FieldName := 'REFERENCENO';
    wdsJobcardsJOBCARDDATE.SetParentComponent(wdsJobcards);
    wdsJobcardsJOBCARDDATE.Name := 'wdsJobcardsJOBCARDDATE';
    wdsJobcardsJOBCARDDATE.FieldName := 'JOBCARDDATE';
    wdsJobcardsJOBCARDENDDATE.SetParentComponent(wdsJobcards);
    wdsJobcardsJOBCARDENDDATE.Name := 'wdsJobcardsJOBCARDENDDATE';
    wdsJobcardsJOBCARDENDDATE.FieldName := 'JOBCARDENDDATE';
    wdsJobcardsTotalDownTime.SetParentComponent(wdsJobcards);
    wdsJobcardsTotalDownTime.Name := 'wdsJobcardsTotalDownTime';
    wdsJobcardsTotalDownTime.FieldName := 'TotalDownTime';
    wdsJobcardsDOCKETNO.SetParentComponent(wdsJobcards);
    wdsJobcardsDOCKETNO.Name := 'wdsJobcardsDOCKETNO';
    wdsJobcardsDOCKETNO.FieldName := 'DOCKETNO';
    wdsJobcardsCOSTGROUP.SetParentComponent(wdsJobcards);
    wdsJobcardsCOSTGROUP.Name := 'wdsJobcardsCOSTGROUP';
    wdsJobcardsCOSTGROUP.FieldName := 'COSTGROUP';
    wdsJobcardsServiceType.SetParentComponent(wdsJobcards);
    wdsJobcardsServiceType.Name := 'wdsJobcardsServiceType';
    wdsJobcardsServiceType.FieldName := 'ServiceType';
    wdsJobcardsINSTRUCTIONMEMO.SetParentComponent(wdsJobcards);
    wdsJobcardsINSTRUCTIONMEMO.Name := 'wdsJobcardsINSTRUCTIONMEMO';
    wdsJobcardsINSTRUCTIONMEMO.FieldName := 'INSTRUCTIONMEMO';
    wdsJobcardsSystemtype.SetParentComponent(wdsJobcards);
    wdsJobcardsSystemtype.Name := 'wdsJobcardsSystemtype';
    wdsJobcardsSystemtype.FieldName := 'Systemtype';
    dsJobcards.SetParentComponent(Self);
    dsJobcards.Name := 'dsJobcards';
    dsJobcards.DataSet := wdsJobcards;
    dsJobcards.Left := 280;
    dsJobcards.Top := 24;
    wdsJCDStandard.SetParentComponent(Self);
    wdsJCDStandard.Name := 'wdsJCDStandard';
    wdsJCDStandard.Connection := dmData.dbConnect;
    wdsJCDStandard.Left := 80;
    wdsJCDStandard.Top := 446;
    wdsJCDStandardstockREPLACE.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardstockREPLACE.Name := 'wdsJCDStandardstockREPLACE';
    wdsJCDStandardstockREPLACE.FieldName := 'stockREPLACE';
    wdsJCDStandardVehicleType.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardVehicleType.Name := 'wdsJCDStandardVehicleType';
    wdsJCDStandardVehicleType.FieldName := 'VehicleType';
    wdsJCDStandardglcode.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardglcode.Name := 'wdsJCDStandardglcode';
    wdsJCDStandardglcode.FieldName := 'glcode';
    wdsJCDStandardREQQTY.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardREQQTY.Name := 'wdsJCDStandardREQQTY';
    wdsJCDStandardREQQTY.FieldName := 'REQQTY';
    wdsJCDStandardstockQTY.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardstockQTY.Name := 'wdsJCDStandardstockQTY';
    wdsJCDStandardstockQTY.FieldName := 'stockQTY';
    wdsJCDStandardstockUNITPRICE.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardstockUNITPRICE.Name := 'wdsJCDStandardstockUNITPRICE';
    wdsJCDStandardstockUNITPRICE.FieldName := 'stockUNITPRICE';
    wdsJCDStandardTOTALEXCL.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardTOTALEXCL.Name := 'wdsJCDStandardTOTALEXCL';
    wdsJCDStandardTOTALEXCL.FieldName := 'TOTALEXCL';
    wdsJCDStandardTOTALVAT.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardTOTALVAT.Name := 'wdsJCDStandardTOTALVAT';
    wdsJCDStandardTOTALVAT.FieldName := 'TOTALVAT';
    wdsJCDStandardTOTALINCL.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardTOTALINCL.Name := 'wdsJCDStandardTOTALINCL';
    wdsJCDStandardTOTALINCL.FieldName := 'TOTALINCL';
    wdsJCDStandardreason.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardreason.Name := 'wdsJCDStandardreason';
    wdsJCDStandardreason.FieldName := 'reason';
    wdsJCDStandardWarehouse.SetParentComponent(wdsJCDStandard);
    wdsJCDStandardWarehouse.Name := 'wdsJCDStandardWarehouse';
    wdsJCDStandardWarehouse.FieldName := 'Warehouse';
    dsJCDStandard.SetParentComponent(Self);
    dsJCDStandard.Name := 'dsJCDStandard';
    dsJCDStandard.DataSet := wdsJCDStandard;
    dsJCDStandard.Left := 88;
    dsJCDStandard.Top := 510;
    dsJCDRM.SetParentComponent(Self);
    dsJCDRM.Name := 'dsJCDRM';
    dsJCDRM.DataSet := wdsJCDRM;
    dsJCDRM.Left := 264;
    dsJCDRM.Top := 534;
    dsICDOther.SetParentComponent(Self);
    dsICDOther.Name := 'dsICDOther';
    dsICDOther.DataSet := wdsJCDOther;
    dsICDOther.Left := 576;
    dsICDOther.Top := 534;
    wdsJCDRM.SetParentComponent(Self);
    wdsJCDRM.Name := 'wdsJCDRM';
    wdsJCDRM.Connection := dmData.dbConnect;
    wdsJCDRM.Left := 264;
    wdsJCDRM.Top := 454;
    wdsJCDRMstockREPLACE.SetParentComponent(wdsJCDRM);
    wdsJCDRMstockREPLACE.Name := 'wdsJCDRMstockREPLACE';
    wdsJCDRMstockREPLACE.FieldName := 'stockREPLACE';
    wdsJCDRMVehicleType.SetParentComponent(wdsJCDRM);
    wdsJCDRMVehicleType.Name := 'wdsJCDRMVehicleType';
    wdsJCDRMVehicleType.FieldName := 'VehicleType';
    wdsJCDRMglcode.SetParentComponent(wdsJCDRM);
    wdsJCDRMglcode.Name := 'wdsJCDRMglcode';
    wdsJCDRMglcode.FieldName := 'glcode';
    wdsJCDRMREQQTY.SetParentComponent(wdsJCDRM);
    wdsJCDRMREQQTY.Name := 'wdsJCDRMREQQTY';
    wdsJCDRMREQQTY.FieldName := 'REQQTY';
    wdsJCDRMstockQTY.SetParentComponent(wdsJCDRM);
    wdsJCDRMstockQTY.Name := 'wdsJCDRMstockQTY';
    wdsJCDRMstockQTY.FieldName := 'stockQTY';
    wdsJCDRMstockUNITPRICE.SetParentComponent(wdsJCDRM);
    wdsJCDRMstockUNITPRICE.Name := 'wdsJCDRMstockUNITPRICE';
    wdsJCDRMstockUNITPRICE.FieldName := 'stockUNITPRICE';
    wdsJCDRMTOTALEXCL.SetParentComponent(wdsJCDRM);
    wdsJCDRMTOTALEXCL.Name := 'wdsJCDRMTOTALEXCL';
    wdsJCDRMTOTALEXCL.FieldName := 'TOTALEXCL';
    wdsJCDRMTOTALVAT.SetParentComponent(wdsJCDRM);
    wdsJCDRMTOTALVAT.Name := 'wdsJCDRMTOTALVAT';
    wdsJCDRMTOTALVAT.FieldName := 'TOTALVAT';
    wdsJCDRMTOTALINCL.SetParentComponent(wdsJCDRM);
    wdsJCDRMTOTALINCL.Name := 'wdsJCDRMTOTALINCL';
    wdsJCDRMTOTALINCL.FieldName := 'TOTALINCL';
    wdsJCDRMreason.SetParentComponent(wdsJCDRM);
    wdsJCDRMreason.Name := 'wdsJCDRMreason';
    wdsJCDRMreason.FieldName := 'reason';
    wdsJCDRMWarehouse.SetParentComponent(wdsJCDRM);
    wdsJCDRMWarehouse.Name := 'wdsJCDRMWarehouse';
    wdsJCDRMWarehouse.FieldName := 'Warehouse';
    wdsJCDOther.SetParentComponent(Self);
    wdsJCDOther.Name := 'wdsJCDOther';
    wdsJCDOther.Connection := dmData.dbConnect;
    wdsJCDOther.Left := 576;
    wdsJCDOther.Top := 478;
    wdsJCDOtherstockREPLACE.SetParentComponent(wdsJCDOther);
    wdsJCDOtherstockREPLACE.Name := 'wdsJCDOtherstockREPLACE';
    wdsJCDOtherstockREPLACE.FieldName := 'stockREPLACE';
    wdsJCDOtherVehicleType.SetParentComponent(wdsJCDOther);
    wdsJCDOtherVehicleType.Name := 'wdsJCDOtherVehicleType';
    wdsJCDOtherVehicleType.FieldName := 'VehicleType';
    wdsJCDOtherglcode.SetParentComponent(wdsJCDOther);
    wdsJCDOtherglcode.Name := 'wdsJCDOtherglcode';
    wdsJCDOtherglcode.FieldName := 'glcode';
    wdsJCDOtherREQQTY.SetParentComponent(wdsJCDOther);
    wdsJCDOtherREQQTY.Name := 'wdsJCDOtherREQQTY';
    wdsJCDOtherREQQTY.FieldName := 'REQQTY';
    wdsJCDOtherstockQTY.SetParentComponent(wdsJCDOther);
    wdsJCDOtherstockQTY.Name := 'wdsJCDOtherstockQTY';
    wdsJCDOtherstockQTY.FieldName := 'stockQTY';
    wdsJCDOtherstockUNITPRICE.SetParentComponent(wdsJCDOther);
    wdsJCDOtherstockUNITPRICE.Name := 'wdsJCDOtherstockUNITPRICE';
    wdsJCDOtherstockUNITPRICE.FieldName := 'stockUNITPRICE';
    wdsJCDOtherTOTALEXCL.SetParentComponent(wdsJCDOther);
    wdsJCDOtherTOTALEXCL.Name := 'wdsJCDOtherTOTALEXCL';
    wdsJCDOtherTOTALEXCL.FieldName := 'TOTALEXCL';
    wdsJCDOtherTOTALVAT.SetParentComponent(wdsJCDOther);
    wdsJCDOtherTOTALVAT.Name := 'wdsJCDOtherTOTALVAT';
    wdsJCDOtherTOTALVAT.FieldName := 'TOTALVAT';
    wdsJCDOtherTOTALINCL.SetParentComponent(wdsJCDOther);
    wdsJCDOtherTOTALINCL.Name := 'wdsJCDOtherTOTALINCL';
    wdsJCDOtherTOTALINCL.FieldName := 'TOTALINCL';
    wdsJCDOtherreason.SetParentComponent(wdsJCDOther);
    wdsJCDOtherreason.Name := 'wdsJCDOtherreason';
    wdsJCDOtherreason.FieldName := 'reason';
    wdsJCDOtherWarehouse.SetParentComponent(wdsJCDOther);
    wdsJCDOtherWarehouse.Name := 'wdsJCDOtherWarehouse';
    wdsJCDOtherWarehouse.FieldName := 'Warehouse';
    wcTruckTrailers.SetParentComponent(Self);
    wcTruckTrailers.Name := 'wcTruckTrailers';
    wcTruckTrailers.Connection := dmData.dbConnect;
    wcTruckTrailers.Left := 184;
    wcTruckTrailers.Top := 140;
    wdsTruckTrailers.SetParentComponent(Self);
    wdsTruckTrailers.Name := 'wdsTruckTrailers';
    wdsTruckTrailers.Connection := dmData.dbConnect;
    wdsTruckTrailers.Left := 248;
    wdsTruckTrailers.Top := 140;
    wdsTruckTrailersRegNo.SetParentComponent(wdsTruckTrailers);
    wdsTruckTrailersRegNo.Name := 'wdsTruckTrailersRegNo';
    wdsTruckTrailersRegNo.FieldName := 'RegNo';
    wdsTruckTrailersPosition.SetParentComponent(wdsTruckTrailers);
    wdsTruckTrailersPosition.Name := 'wdsTruckTrailersPosition';
    wdsTruckTrailersPosition.FieldName := 'Position';
    dsTruckTrailers.SetParentComponent(Self);
    dsTruckTrailers.Name := 'dsTruckTrailers';
    dsTruckTrailers.DataSet := wdsTruckTrailers;
    dsTruckTrailers.Left := 312;
    dsTruckTrailers.Top := 140;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    TMSFNCPageControl1.AfterLoadDFMValues;
    TMSFNCPageControl1Page1.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    TMSFNCDataGrid2.AfterLoadDFMValues;
    dgdbaJCDRM.AfterLoadDFMValues;
    TMSFNCPageControl1Page2.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    TMSFNCDataGrid3.AfterLoadDFMValues;
    dgdbaJCDOther.AfterLoadDFMValues;
    TMSFNCPageControl1Page0.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgdbaJCDStandard.AfterLoadDFMValues;
    WebPanel8.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebPanel7.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    WebDBLabel2.AfterLoadDFMValues;
    WebDBLabel3.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebDBLabel6.AfterLoadDFMValues;
    WebDBLabel8.AfterLoadDFMValues;
    WebDBLabel9.AfterLoadDFMValues;
    WebDBLabel10.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebDBLabel11.AfterLoadDFMValues;
    WebDBLabel12.AfterLoadDFMValues;
    WebDBLabel13.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebDBLabel14.AfterLoadDFMValues;
    WebDBMemo1.AfterLoadDFMValues;
    TMSFNCDataGrid4.AfterLoadDFMValues;
    dgdbaTruckTrailers.AfterLoadDFMValues;
    wcJobCards.AfterLoadDFMValues;
    wdsJobcards.AfterLoadDFMValues;
    wdsJobcardsCompany.AfterLoadDFMValues;
    wdsJobcardsSite.AfterLoadDFMValues;
    wdsJobcardsTRUCKREGNO.AfterLoadDFMValues;
    wdsJobcardsKMREADING.AfterLoadDFMValues;
    wdsJobcardsORDERNO.AfterLoadDFMValues;
    wdsJobcardsREFERENCENO.AfterLoadDFMValues;
    wdsJobcardsJOBCARDDATE.AfterLoadDFMValues;
    wdsJobcardsJOBCARDENDDATE.AfterLoadDFMValues;
    wdsJobcardsTotalDownTime.AfterLoadDFMValues;
    wdsJobcardsDOCKETNO.AfterLoadDFMValues;
    wdsJobcardsCOSTGROUP.AfterLoadDFMValues;
    wdsJobcardsServiceType.AfterLoadDFMValues;
    wdsJobcardsINSTRUCTIONMEMO.AfterLoadDFMValues;
    wdsJobcardsSystemtype.AfterLoadDFMValues;
    dsJobcards.AfterLoadDFMValues;
    wdsJCDStandard.AfterLoadDFMValues;
    wdsJCDStandardstockREPLACE.AfterLoadDFMValues;
    wdsJCDStandardVehicleType.AfterLoadDFMValues;
    wdsJCDStandardglcode.AfterLoadDFMValues;
    wdsJCDStandardREQQTY.AfterLoadDFMValues;
    wdsJCDStandardstockQTY.AfterLoadDFMValues;
    wdsJCDStandardstockUNITPRICE.AfterLoadDFMValues;
    wdsJCDStandardTOTALEXCL.AfterLoadDFMValues;
    wdsJCDStandardTOTALVAT.AfterLoadDFMValues;
    wdsJCDStandardTOTALINCL.AfterLoadDFMValues;
    wdsJCDStandardreason.AfterLoadDFMValues;
    wdsJCDStandardWarehouse.AfterLoadDFMValues;
    dsJCDStandard.AfterLoadDFMValues;
    dsJCDRM.AfterLoadDFMValues;
    dsICDOther.AfterLoadDFMValues;
    wdsJCDRM.AfterLoadDFMValues;
    wdsJCDRMstockREPLACE.AfterLoadDFMValues;
    wdsJCDRMVehicleType.AfterLoadDFMValues;
    wdsJCDRMglcode.AfterLoadDFMValues;
    wdsJCDRMREQQTY.AfterLoadDFMValues;
    wdsJCDRMstockQTY.AfterLoadDFMValues;
    wdsJCDRMstockUNITPRICE.AfterLoadDFMValues;
    wdsJCDRMTOTALEXCL.AfterLoadDFMValues;
    wdsJCDRMTOTALVAT.AfterLoadDFMValues;
    wdsJCDRMTOTALINCL.AfterLoadDFMValues;
    wdsJCDRMreason.AfterLoadDFMValues;
    wdsJCDRMWarehouse.AfterLoadDFMValues;
    wdsJCDOther.AfterLoadDFMValues;
    wdsJCDOtherstockREPLACE.AfterLoadDFMValues;
    wdsJCDOtherVehicleType.AfterLoadDFMValues;
    wdsJCDOtherglcode.AfterLoadDFMValues;
    wdsJCDOtherREQQTY.AfterLoadDFMValues;
    wdsJCDOtherstockQTY.AfterLoadDFMValues;
    wdsJCDOtherstockUNITPRICE.AfterLoadDFMValues;
    wdsJCDOtherTOTALEXCL.AfterLoadDFMValues;
    wdsJCDOtherTOTALVAT.AfterLoadDFMValues;
    wdsJCDOtherTOTALINCL.AfterLoadDFMValues;
    wdsJCDOtherreason.AfterLoadDFMValues;
    wdsJCDOtherWarehouse.AfterLoadDFMValues;
    wcTruckTrailers.AfterLoadDFMValues;
    wdsTruckTrailers.AfterLoadDFMValues;
    wdsTruckTrailersRegNo.AfterLoadDFMValues;
    wdsTruckTrailersPosition.AfterLoadDFMValues;
    dsTruckTrailers.AfterLoadDFMValues;
  end;
end;

end.
